import { render, staticRenderFns } from "./playground-graph.vue?vue&type=template&id=145741fa&scoped=true"
import script from "./playground-graph.vue?vue&type=script&lang=js"
export * from "./playground-graph.vue?vue&type=script&lang=js"
import style0 from "./playground-graph.vue?vue&type=style&index=0&id=145741fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145741fa",
  null
  
)

/* custom blocks */
import block0 from "./playground-graph.vue?vue&type=custom&index=0&blockType=i18n&lang=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InfoAlert: require('/home/runner/work/frontpages/frontpages/component-library/src/components/molecules/alerts/info-alert.vue').default})
